import React from 'react';
import { properties } from '../../../data/mockData';
import { PropertyCard } from '../../../components/shared/PropertyCard';
export const SavedProperties = () => {
  const saved = properties.slice(0, 4);
  return <div className="space-y-6 animate-in fade-in" data-id="element-1355">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1356">
        <div data-id="element-1357">
          <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1358">
            Saved Properties
          </h1>
          <p className="text-text-light" data-id="element-1359">
            Properties you've favorited for later.
          </p>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2 custom-scrollbar" data-id="element-1360">
        <button className="px-4 py-2 rounded-lg bg-primary-900 text-white text-sm font-bold whitespace-nowrap" data-id="element-1361">
          All Saved (4)
        </button>
        <button className="px-4 py-2 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1362">
          Tier 1 (2)
        </button>
        <button className="px-4 py-2 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1363">
          Tier 2 (1)
        </button>
        <button className="px-4 py-2 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1364">
          Tier 3 (1)
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-1365">
        {saved.map(p => <PropertyCard key={p.id} property={p} data-id="element-1366" />)}
      </div>
    </div>;
};